import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/promotion/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

export function setReal(data) {
  return request.send({
    url: `/pmy/sys/promotion/audit`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
